module.exports = "\n<form class=\"-client-add\"\n      v-on:submit.prevent=\"submit\"\n      action=\"\">\n    <person-form :data.sync=\"data\"></person-form>\n\n    <div class=\"row\">\n        <div class=\"col-sm-12 cta\">\n            <button type=\"submit\" class=\"btn btn-primary -add-individual\">\n                Créer\n            </button>\n        </div>\n    </div>\n</form>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/AddIndividual.vue
// module id = 490
// module chunks = 0